(function(){
  function init(){
    var dpr=Math.min(window.devicePixelRatio||1,2);
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var motion=!reduce, intensity=0.9, shape='dust', golds=['#F7E6AE','#EAD08A','#C9A14C','#A07C33','#F2D98E'];
    var cv=[].slice.call(document.querySelectorAll('#delhadi-mag canvas[data-flake]'));
    if(!cv.length) return;
    function setup(c){
      var r=c.getBoundingClientRect(); if(r.width<2||r.height<2) return;
      c.width=Math.round(r.width*dpr); c.height=Math.round(r.height*dpr);
      var density = shape==='dust' ? 0.00020 : 0.000085;
      var n=Math.max(8,Math.round(r.width*r.height*density*(0.45+intensity))), ps=[];
      for(var i=0;i<n;i++){var b=Math.random();ps.push({x:Math.random()*c.width,y:Math.random()*c.height,s:(shape==='dust'?(0.5+b*1.5):(1+b*b*7))*dpr,rot:Math.random()*Math.PI,vr:(Math.random()-0.5)*0.012,tw:Math.random()*Math.PI*2,tws:0.5+Math.random()*1.7,col:golds[(Math.random()*golds.length)|0],base:0.22+Math.random()*0.6});}
      c._ps=ps;
    }
    cv.forEach(setup);
    if(window.ResizeObserver){var ro=new ResizeObserver(function(es){es.forEach(function(e){setup(e.target);});});cv.forEach(function(c){ro.observe(c);});}
    var last=performance.now();
    function frame(now){
      var dt=Math.min(0.05,(now-last)/1000); last=now;
      for(var k=0;k<cv.length;k++){var c=cv[k]; if(!c._ps) continue;
        var rect=c.getBoundingClientRect(); if(rect.bottom<-150||rect.top>window.innerHeight+150) continue;
        var ctx=c.getContext('2d'); if(!ctx) continue;
        ctx.clearRect(0,0,c.width,c.height); ctx.globalCompositeOperation='lighter';
        for(var j=0;j<c._ps.length;j++){var p=c._ps[j];
          if(motion){p.tw+=p.tws*dt;p.rot+=p.vr;}
          var al=p.base*(0.5+0.5*Math.sin(p.tw));
          ctx.save();ctx.translate(p.x,p.y);ctx.rotate(p.rot);
          ctx.globalAlpha=Math.max(0,Math.min(1,al));ctx.fillStyle=p.col;
          if(shape==='dust'){ctx.beginPath();ctx.arc(0,0,p.s,0,7);ctx.fill();}
          else {ctx.beginPath();ctx.moveTo(-p.s,0);ctx.lineTo(0,-p.s*0.66);ctx.lineTo(p.s,p.s*0.12);ctx.lineTo(p.s*0.14,p.s*0.82);ctx.closePath();ctx.fill();}
          ctx.restore();
        }
        ctx.globalCompositeOperation='source-over';
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();